// extracted by mini-css-extract-plugin
export default {"logo":"loadingScreen_logo__RxYE7","loadingBox":"loadingScreen_loadingBox__SVtKN","loader":"loadingScreen_loader__jm1g7","load":"loadingScreen_load__17CX-"};